import React, { useEffect, useState } from "react";
import {
  Badge,
  Card,
  Checkbox,
  CheckboxChangeEvent,
  Flex,
  Space,
  Typography,
} from "antd";
import { BsMegaphone } from "react-icons/bs";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import ReactCountryFlag from "react-country-flag";
import CustomLoader from "../../common/UI/Loader";
import "./index.scss";

const MegaphoneIcon = BsMegaphone as unknown as React.FC;
const { Text, Title } = Typography;

interface ContactCardProps {
  checkbox?: boolean;
  checked?: boolean;
  onChecked?: (checked: boolean) => void;
  userName?: string;
  phoneNumber?: string;
  isEfone?: boolean;
  onClick?: () => void;
  isBroadCast?: boolean;
  isGroup?: boolean;
  loading?: boolean;
}

const ContactCard: React.FC<ContactCardProps> = ({
  checkbox = false,
  checked = false,
  loading = false,
  onChecked,
  userName,
  phoneNumber,
  isEfone,
  onClick,
  isBroadCast,
  isGroup,
}) => {
  const [countryCode, setCountryCode] = useState("");

  const handleToggle = () => {
    if (checkbox) {
      onChecked?.(!checked);
    }
    onClick?.();
  };

  const handleCheckbox = (e: CheckboxChangeEvent) => {
    e.stopPropagation();
    onChecked?.(e.target.checked);
  };

  const getCountryCode = (number: string) => {
    const parsed = parsePhoneNumberFromString(number);
    setCountryCode(parsed?.country || "");
    return parsed?.country || "";
  };

  useEffect(() => {
    if (phoneNumber) {
      getCountryCode(phoneNumber);
    }
  }, [phoneNumber]);

  return (
    <Card className="contact-card" onClick={handleToggle}>
      <div
        className={`avatar-container ${
          isEfone ? "avatar-efone" : "avatar-non-efone"
        }`}
      >
        {isBroadCast ? (
          <Flex style={{ fontSize: "18px" }}>
            <MegaphoneIcon />
          </Flex>
        ) : (
          <div>{userName?.slice(0, 1)}</div>
        )}
      </div>
      <div className="contact-description">
        <Space direction="vertical" size={2}>
          <Flex align="center" gap={8}>
            <Title className="user-name">{userName}</Title>
            {checkbox ? <Badge className="badge">Free</Badge> : null}
          </Flex>
          {userName !== phoneNumber && (
            <Flex align="center" gap={8}>
              {countryCode && (
                <div className="flag">
                  <ReactCountryFlag svg countryCode={countryCode} />
                </div>
              )}
              <Text className="user-phone">{phoneNumber}</Text>
            </Flex>
          )}
        </Space>
        <Flex align="center" gap={8}>
          {isEfone && !checkbox && !isBroadCast && !isGroup ? (
            <Badge className="badge">Free</Badge>
          ) : null}

          {checkbox && (
            <Checkbox
              className="custom-checkbox"
              checked={checked}
              onChange={handleCheckbox}
              onClick={(e) => e.stopPropagation()} // avoid double toggle
            />
          )}

          {loading && <CustomLoader color="#dbe3f8" />}
        </Flex>
      </div>
    </Card>
  );
};

export default ContactCard;
